import React from 'react';

const ProductSkeleton = () => {
  return (
    <div className="group relative bg-white rounded-2xl overflow-hidden shadow-sm animate-pulse">
      {/* Image Skeleton */}
      <div className="aspect-square bg-gray-200"></div>
      
      {/* Content Skeleton */}
      <div className="p-4 space-y-3">
        {/* Title */}
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        
        {/* Brand */}
        <div className="h-3 bg-gray-200 rounded w-1/2"></div>
        
        {/* Rating */}
        <div className="flex items-center space-x-1">
          <div className="h-3 w-3 bg-gray-200 rounded"></div>
          <div className="h-3 w-3 bg-gray-200 rounded"></div>
          <div className="h-3 w-3 bg-gray-200 rounded"></div>
          <div className="h-3 w-3 bg-gray-200 rounded"></div>
          <div className="h-3 w-3 bg-gray-200 rounded"></div>
          <div className="h-3 bg-gray-200 rounded w-8 mr-2"></div>
        </div>
        
        {/* Price */}
        <div className="flex items-center justify-between">
          <div className="h-5 bg-gray-200 rounded w-16"></div>
          <div className="h-8 bg-gray-200 rounded w-8"></div>
        </div>
      </div>
    </div>
  );
};

const ProductSkeletonGrid = ({ count = 8 }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  );
};

export default ProductSkeleton;
export { ProductSkeletonGrid };

